import Api from "./Api";

class AppDataService {
    get = () => {
        return Api().get(`app-settings`)
    }

}

export default new AppDataService();